import { bindHTTP } from '@frontend/schema';
import { TagService } from '@weave/schema-gen-ts/dist/schemas/tag/v2/tag_service_v2.pb';
export const SchemaTagsServiceV2 = bindHTTP(TagService);
export const serviceName = 'tag-v2';
